/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StockDto { 
    id?: number;
    quantity?: number;
    reservedAmount?: number | null;
    articleName?: string | null;
    articleCode?: string | null;
    articleDescription?: string | null;
    availabilityDate?: string;
    expirationDate?: string;
    deliveryDate?: string;
    destinationHub?: string | null;
    destinationCDC?: string | null;
    type?: number;
    forcedAvailability?: boolean;
    nested?: Array<StockDto> | null;
}

